import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { firstLetter } from '../../utils/formater';
import { showAuthForm } from '../../app/Auth/actions';
import { IconSaveSearch } from '../Icons';

import { Price } from '../Price';

import { Link } from 'react-router-dom';

class UserMenu extends Component {
  constructor (props) {
    super(props);

    this.loginForm = this.loginForm.bind(this);
  }
  getFavorites () {
    if (!this.props.user.get('loaded')) {
      return 0;
    }

    return this.props.user.getIn(['data', 'favoritesStatistics', 'totalCount'], 0);
  }

  getSavedSerches () {
    if (!this.props.user.get('loaded')) {
      return 0;
    }

    return this.props.user.getIn(['data', 'statistics', 'savedSearchCount'], 0);
  }

  loginForm (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.showAuthForm('signin');
  }

  renderLogin () {
    // TODO: сделать авторизацию через всплывающее окно
    return (
      <a className='login' href='/user/default/login/'>Войти</a>
    );
  }

  renderMenu (user) {
    const avatar = firstLetter(user.get('fullName'));
    return (
      <div className='popup-menu'>
        <div className='avatar'>{avatar || 'К'}</div>

        <div className='popup'>
          <div className='corner' />
          <ul>
            <li><a href='/office/office/'>Личный кабинет <span className='badge'>{user.get('id')}</span></a></li>
            <Link to='/saved-searches/'>Мой поиск</Link>
            <li><a href='/office/subscription/index/'>Мои подписки</a></li>
            <li><a href='/user/default/profile/'>Мой профиль</a></li>
            <li><a href='/office/bid/'>Сообщения</a></li>
          </ul>
          <hr />
          <ul>
            <li><a href='/billing/default/pays/'>
              Баланс <span className='badge'><Price value={user.get('balance')} /></span>
            </a></li>
            <li><a href={`/office/billing/report/?consumption=0&userId=${user.get('id')}`}>Детализация</a></li>
            <Link to='/tariffs/'>Тарифы</Link>
            <li><a className='link-orange' href='/user/default/logout/'>Выйти из аккаунта</a></li>
          </ul>
        </div>
      </div>
    );
  }

  render () {
    const user = this.props.user.get('data');

    return (
      <div className='lk-menu'>

        <Link to='/saved-searches/' className='saved-search'>
          <IconSaveSearch color="#d8d8d8" height='23' width='23' />
          <span className='bookmark-counter'>{this.getSavedSerches()}</span>
        </Link>

        <Link to='/favorites/' className='favorites'>
          <span className="icon-heart">
            <span className="path1"></span>
            <span className="path2"></span>
          </span>
          <span className='bookmark-counter'>{this.getFavorites()}</span>
        </Link>

        <a className='add-announcement' href='/user/default/add/'>
          <span className='icon-circled-plus' />
          Добавить объявление
        </a>

        {user && user.size ? this.renderMenu(user) : this.renderLogin()}
      </div>
    );
  }
}

UserMenu.propTypes = {
  user: PropTypes.object.isRequired,
  showAuthForm: PropTypes.func.isRequired
};

UserMenu.defaultProps = {};

function mapStateToProps (state) {
  return {
    user: state.get('user')
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    showAuthForm
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);



// WEBPACK FOOTER //
// ./src/ui/Menu/UserMenu.js